import { useState } from 'react';

import { useRouter } from 'next/router';

import { useMessaging } from '@core/messaging';
import {
  Quote,
  useErrorCodeTranslation,
  registerFreeInsurancePaylink
} from '@core/api';
import InternalApiError from '@lib/errors';

import { callCreatePayment } from '../../Onboarding/quoteService';

const useCreateFreeInsuranceRequest = () => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const messaging = useMessaging();
  const { getErrorTranslation } = useErrorCodeTranslation();

  const pay = async (quote: Quote) => {
    if (!quote) return;

    setIsLoading(true);

    try {
      const data = await callCreatePayment(quote);

      if (!('hostedPaymentPageUrl' in data)) {
        throw new Error('Missing paylink');
      }

      await registerFreeInsurancePaylink({
        paylink: data.hostedPaymentPageUrl
      });
      router.push('/onboarding/success?freeInsurance=true');
    } catch (error) {
      const code = error instanceof InternalApiError ? error.code : -1;

      messaging.addMessage({
        toastType: 'error',
        message: getErrorTranslation(code)
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { pay, isLoading };
};

export default useCreateFreeInsuranceRequest;
